import * as React from "react";

function SvgArrowRightIcon(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" width="1em" height="1em" viewBox="0 0 5.891 9.995" {...props}><rect x={0.5} y={11.401} width={0.282} height={6.049} rx={0.141} stroke="currentColor" transform="rotate(-135 .265 10.26)" /><rect x={9.588} y={10.495} width={0.282} height={6.049} rx={0.141} stroke="currentColor" transform="rotate(-45 -6.426 16.421)" /></svg>;
}

export default SvgArrowRightIcon;